export default [
  {
    text: "D",
    value: "D"
  },
  {
    text: "M",
    value: "M"
  },
  {
    text: "S",
    value: "S"
  },
  {
    text: "W",
    value: "W"
  },
  {
    text: "Y",
    value: "Y"
  }
];
